import { useFormStore } from '@/stores/form'
import router from '@/router'
import apiHelperService from '@/services'
import { useGlobalStore } from '@/stores/global'

const initForm = async () => {
  const formStore = useFormStore()
  const globalStore = useGlobalStore()
  const { serviceTransactionId } = globalStore.startedService
  const {
    fileNumber = '',
    sponsoredUN = '',
    fileModuleId = '',
    isCanceled = '',
    withException = '',
    administrativeRegionId = ''
  } = router.currentRoute.value.query

  formStore.extraMap = {
    ...formStore.extraMap,
    fileNumber,
    fileModuleId,
    isCanceled,
    serviceTransactionId,
    administrativeRegionId,
    withException: withException == 'true'
  }

  if (sponsoredUN) {
    let res = await apiHelperService.post(
      `/api/individual/personImmigrationFile/prepareWithCanceledFilesValidition`,
      {
        sponsoredFileNumber: fileNumber,
        canceledSponsoredFlag: isCanceled,
        fileModuleId
      }
    )
    if (res) {
      const { residencyRequest = {}, visaRequest = {} } = res || {}
      if (fileModuleId == 2) {
        setDefaultVal(visaRequest)
      } else {
        setDefaultVal(residencyRequest)
      }
      initLeavePermitNumber({
        unifiedNumber: sponsoredUN,
        sponsoredFileNumber: fileNumber,
        fileModuleId: fileModuleId
      })
    }
  }
}

const setDefaultVal = (res) => {
  const formStore = useFormStore()
  const { sponsorNumber = '', passportCountryId = '' } = res

  formStore.draft.request = {
    ...formStore.draft.request,
    ...res,
    sponsorFileNumber: sponsorNumber,
    passportIssueCountryId: passportCountryId
  }
}

const initLeavePermitNumber = async (params) => {
  const formStore = useFormStore()
  const res = await apiHelperService.post(`/api/individual/investigation/getLeavePermit`, {
    ...params
  })
  if (res) {
    const {
      leavePermitDepartmentCode = '',
      leavePermitYear = '',
      leavePermitSequenceNumber = ''
    } = res
    formStore.draft.request = {
      ...formStore.draft.request,
      leavePermitNumberYear: leavePermitYear,
      leavePermitNumberDept: leavePermitDepartmentCode,
      leavePermitNumberSerial: leavePermitSequenceNumber
    }
  }
}

export default async function () {
  try {
    await initForm()
  } catch (error) {
    console.error('use495Preload error: ', error)
  }
}
